import axiosInstance from '../axiosInterceptor/axiosInstance'

const reorderGamedays = async ({ orgId, groupId, orderedIds }) => {
  const url = `v1/orgs/${orgId}/gamedays/reorder?groupId=${groupId}`
  const response = await axiosInstance.patch(url, JSON.stringify({ orderedIds }))
  return response?.data
}

export default reorderGamedays
